import Enumerable from "linq";
import { ProRadDrawExecuteResult, ProRadDrawExecuteRequest } from "../../../../domain/localhost/items";
import { IProRadDrawExecuteResultBean, IProRadDrawExecuteRequestBean } from "../beans";
import { IDocumentImageSource, ImageSourceKinds } from "../../../../domain/document";
import { ImageSource } from "../../../../infrastructure/document/ver2";

export class ProRadDrawParameterTranslator {
  static toProRadDrawExecuteResult(bean: IProRadDrawExecuteResultBean, getToken: () => string): ProRadDrawExecuteResult {
    if (!bean) { return null; }
    const result = new ProRadDrawExecuteResult();
    result.isComplete = bean.isComplete;
    result.images = Enumerable.from(bean.images).select(i => {
      return {
        sourceGuid: i.sourceGuid,
        imageSource: this.createImageSource(i.cacheGuid, getToken),
      };
    }).toArray();
    return result;
  }

  private static createImageSource(cacheGuid: string, getToken: () => string): IDocumentImageSource {
    if (!cacheGuid || cacheGuid === "") { return null; }
    return new ImageSource(getToken, null, null, ImageSourceKinds.Cache, cacheGuid);
  }

  static toProRadDrawExecuteRequestBean(request: ProRadDrawExecuteRequest): IProRadDrawExecuteRequestBean {
    if (!request) { return null; }
    if (!(request instanceof ProRadDrawExecuteRequest)) { throw new Error("invalid request!!!"); }
    return {
      images: request.images,
    };
  }
}
